const getDefaultState = () => ({
  isLoading: true,
  data: null,
});

export const state = () => getDefaultState();

export const actions = {
  CLEAR_DATA({ commit }) {
    commit('CLEAR_DATA');
  },
  async GET_IMPORTED_ACTIVITY({ commit }, id) {
    commit('SET_IS_LOADING', true);
    try {
      const response = await this.$axios.$get(`/api/imported-activities/${id}`);
      commit('SET_DATA', response.data);
      commit('SET_IS_LOADING', false);
    } catch (e) {
      commit('SET_IS_LOADING', false);
      return Promise.reject(e);
    }
  },
};

export const mutations = {
  CLEAR_DATA(state) {
    Object.assign(state, getDefaultState());
  },
  SET_IS_LOADING(state, value) {
    state.isLoading = value;
  },
  SET_DATA(state, data) {
    state.data = data;
  },
};
